export default "__VITE_ASSET__rdU8vscJ__"